// Lookup identities only: retain the original backend values in state and save payloads.
export const isMissingSourceValue = value =>
    value === undefined ||
    value === null ||
    (typeof value === "string" && value.trim() === "") ||
    value === "Not provided" ||
    value === "No data provided";

export const getSourceValueKey = value => (isMissingSourceValue(value) ? "Not provided" : value);

export const sourceValuesMatch = (left, right) => getSourceValueKey(left) === getSourceValueKey(right);

export const getCategorySourceKey = (categoryName, gender) =>
    JSON.stringify([getSourceValueKey(categoryName), getSourceValueKey(gender)]);

export const normalizeSizeGroupSizes = sizes => [
    ...new Set(
        (Array.isArray(sizes) ? sizes : [])
            .filter(size => size !== null && size !== undefined && size !== "")
            .map(String)
    )
];

export const getSizeGroupKey = sizes => JSON.stringify(normalizeSizeGroupSizes(sizes).sort());

export const getCategoryMappingKey = mapping =>
    JSON.stringify([
        getCategorySourceKey(mapping?.labelBrandCategoryName, mapping?.labelBrandGenderName),
        getSizeGroupKey(mapping?.labelBrandSizeGroupSizes)
    ]);

export const findCategoryMapping = (mappings, categoryName, gender, sizes) => {
    const sourceKey = getCategorySourceKey(categoryName, gender);
    const candidates = (Array.isArray(mappings) ? mappings : []).filter(
        mapping => getCategorySourceKey(mapping?.labelBrandCategoryName, mapping?.labelBrandGenderName) === sourceKey
    );
    const groupSizes = normalizeSizeGroupSizes(sizes);
    const exact = candidates.find(
        mapping =>
            Array.isArray(mapping.labelBrandSizeGroupSizes) &&
            getSizeGroupKey(mapping.labelBrandSizeGroupSizes) === getSizeGroupKey(groupSizes)
    );
    if (exact) return exact;
    if (groupSizes.length) {
        const scoped = candidates.find(mapping => {
            const savedSizes = normalizeSizeGroupSizes(mapping.labelBrandSizeGroupSizes);
            return savedSizes.length > 0 && groupSizes.every(size => savedSizes.includes(size));
        });
        if (scoped) return scoped;
    }
    return candidates.find(mapping => !mapping.labelBrandSizeGroupSizes?.length);
};
